import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  searchInput: string;

  constructor() { }

  ngOnInit() {
  }

  buscarTramite() {
    window.location.href = 'https://www.argentina.gob.ar/buscar/' + encodeURI(this.searchInput);
  }

}



// WEBPACK FOOTER //
// /opt/snt/front-end-turnos/src/app/layout/header/header.component.ts